import Reveal from "./Reveal";

export default function About({ content, uiStrings, elementVisibility }) {
  const ABOUT_IMG = content?.image || "https://images.unsplash.com/photo-1607746882042-944635dfe10e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";
  const imgAlt = content?.img_alt || uiStrings?.general?.about_img_alt || "Sobre";

  const since = content?.since ? parseInt(content.since) : null;
  const currentYear = new Date().getFullYear();
  const yearsActive = since ? currentYear - since : null;

  const stats = (content?.stats || [
    { n: "11", label: "Anos de atuação", prefix: "" },
    { n: "240", label: "Projetos", prefix: "+" },
    { n: "98%", label: "Indicações", prefix: "" }
  ]).map((stat, idx) => {
    if (idx === 0 && yearsActive) {
      return { ...stat, n: String(yearsActive) };
    }
    return stat;
  });

  return (
    <section id="sobre" data-testid="about-section" className="bg-fendi/30 py-28 md:py-40">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-14 items-center">
        {elementVisibility?.about_image !== false && (
          <Reveal className="lg:col-span-5">
            <div className="relative">
              <img
                src={ABOUT_IMG}
                alt={imgAlt}
                className="w-full h-[400px] md:h-[640px] object-cover"
                loading="lazy"
              />
              {stats.length >= 2 && (
                <div className="absolute -bottom-6 -right-6 bg-offwhite px-8 py-6 border border-fendi hidden md:block">
                  <p className="eyebrow text-warmgray">{stats[0].label}</p>
                  <p className="font-serif text-3xl text-softblack mt-2">{stats[1].prefix || ""}{stats[1].n} {stats[1].label.toLowerCase()}</p>
                </div>
              )}
            </div>
          </Reveal>
        )}

        <Reveal delay={200} className={`${elementVisibility?.about_image !== false ? "lg:col-span-6 lg:col-start-7" : "lg:col-span-8 lg:col-start-3"}`}>
          <p className="eyebrow text-warmgray">{content?.eyebrow || "Sobre"}</p>
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-softblack mt-4 md:mt-6 leading-[1.05]">
            {content?.headline || "Estratégia silenciosa, resultados memoráveis."}
          </h2>
          {(content?.paragraphs?.length > 0
            ? content.paragraphs
            : [content?.description_1, content?.description_2].filter(Boolean)
          ).map((p, i) => (
            <p key={i} className="text-warmgray text-sm sm:text-base md:text-lg leading-relaxed mt-4 md:mt-8 font-light">
              {p}
            </p>
          ))}

          {elementVisibility?.about_stats !== false && (
            <div className="grid grid-cols-3 gap-4 md:gap-8 mt-10 md:mt-12 pt-10 md:pt-12 border-t border-fendi">
              {stats.map((stat, idx) => (
                <Stat key={idx} n={stat.prefix ? `${stat.prefix}${stat.n}` : stat.n} label={stat.label} />
              ))}
            </div>
          )}
        </Reveal>
      </div>
    </section>
  );
}

function Stat({ n, label }) {
  return (
    <div>
      <p className="font-serif text-2xl sm:text-3xl md:text-5xl text-softblack break-words">{n}</p>
      <p className="eyebrow text-warmgray mt-1 md:mt-2 text-[9px] sm:text-[10px] md:text-[11px]">{label}</p>
    </div>
  );
}
